import { useTranslation } from 'react-i18next';
import { Loader, Text } from '@mantine/core';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import { AreaChart } from '@mantine/charts';
import { useGetAnnualStatisticsReport, useGetSalesdReport } from '../../../hooks/reports/queries';
import momentTz from 'moment-timezone';
import HeaderStats from './HeaderStats';

const FullYearSalesGraph = () => {
  const { t } = useTranslation(['ReportsPage', 'FieldName', 'CommonButtons', 'Notifications']);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const searchParamStoreId = searchParams.get('storeId') || '';

  const { data, isLoading } = useGetAnnualStatisticsReport(searchParamStoreId, {
    fromDate: moment().startOf('year').toDate().toISOString(),
    toDate: moment().endOf('year').toDate().toISOString(),
    timezone: momentTz.tz.guess(true)
  });

  if (isLoading) return <Loader />;

  return (
    <>
      <HeaderStats data={data} />
      <Text pt="md" ta={'right'} c={'dimmed'}>
        {t('ReportsPage:dataFrom')}: {moment().startOf('year').format('DD MMMM YYYY')} -{' '}
        {moment().endOf('year').format('DD MMMM YYYY')}
      </Text>
      <AreaChart
        h={300}
        data={Object.keys(data?.annualReport.orders || {})?.map((dayKey: string) => {
          const sale = data?.annualReport?.orders[dayKey];
          return {
            salesDate: dayKey,
            totalSale: sale
          };
        })}
        dataKey="salesDate"
        series={[{ name: 'totalSale', color: '#03A9F4', label: t('FieldName:total') }]}
        curveType="linear"
      />
    </>
  );
};

export default FullYearSalesGraph;
